<div class="container">
  <div class="col">
    <div class="card">
      <div class="card-body">
        
      </div>
    </div>
  </div>
</div>